import moment from 'moment';
import 'moment-timezone';



/**
 * Gets iso string date
 * @param formatted datetime
 */
export const getFormattedDate = ({date, showTime=true}): any => {
  // const locale = navigator.language;//.replace("-", "_");
  //   const time_zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const _date = new Date(date);
    const offset = -1 * new Date().getTimezoneOffset() * 60 * 1000;
    const time = _date.getTime() + offset;
    const d = new Date(time)
  
  const locale = 'fa-IR'//navigator.language;
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const timeOptions= showTime ? { hour: 'numeric', minute: 'numeric', second: 'numeric'} : {}
  const options =  {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric' ,
    hour12: false,
    // timeZone,
    ...timeOptions
  };
  
  return new Intl.DateTimeFormat(locale, options).format(d)
};

// export const showDate = function ({dateTime, showTime=true, locale="fa"}) {
//   const locale = 'fa-IR'//navigator.language;
//   const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
//
//   const options = showTime ? {
//     hour: 'numeric', minute: 'numeric', second: 'numeric',
//     timeZone,
//   } : {};
//
//   return new Intl.DateTimeFormat(locale, options).format(new Date(dateTime))
// };



export const ucFirst = function (string) {
  if (string && string != "") {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  return string;
};


export const isEllipsisActive = (el) => {
  return el && (el.offsetWidth < el.scrollWidth);
};


/**
 * Handle all translated server error messages
 * @param error
 */
export const getErrorMessage = (error) => {
  switch (error.code) {
    case "invalid_input":
      return {
        id: 'app.invalid_input',
        defaultMessage: `User is already exist.`
      };
      
    default:
      return {
        id: 'app.something_bad_happened_try_again',
        defaultMessage: `Something bad happened. Please try again`
      }
  }
};


export const snakeToCamel = str => {
  return str.replace(/([-_][a-z])/g, group =>
    group
      .toLowerCase()
      .replace("-", "")
      .replace("_", "-")
  );
};


export const toUTC = (datetime) => {
  const time = moment(datetime);
  const locale = navigator.language;
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const useroffset = -1 * moment(time).tz(tz)._offset / 60;
  let real_time = time.add(useroffset, 'h');
  const date = new Date(time);
  const system_timezone = date.getTimezoneOffset() / 60;
  
  return real_time.valueOf() - system_timezone * (60 * 60 * 1000);
};


export const showDate = function (dateTime) {
  const locale = navigator.language;
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;

  if (!dateTime || dateTime == "") {
    return "";
  }

  const date = new Date(dateTime);
  const system_timezone = date.getTimezoneOffset() / 60;
  return new Date(dateTime).getTime() + ( -1 * ( system_timezone * (60 * 60 * 1000) ) )

  // return new Date(dateTime).toLocaleString(locale.replace("_", "-"), {timeZone: tz});
};


export const getFormattedPrice = (price) => {
  if (!!price) {
    return `${(price / 10).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} تومان `
  }
  else {
    return 0
  }
};